import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { User } from "../../../domain/models/user/user";

@Injectable({
  providedIn: "root",
})
export class UserService {
  userIsLogged(): boolean {
    const user = this.getUser();
    if (user) {
      return true;
    }
    return false;
  }

  getUser(): User | undefined {
      const user = sessionStorage.getItem("user");
      if (user) {
        return JSON.parse(user);
      }
      return undefined;
  }

  removeUser(): void {
    sessionStorage.removeItem("user");
  }
}
